import {mergeTo, mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import EventDisclaimerView from './event-disclaimer-view.jsx';
import {eventDisclaimerFactory} from './event-disclaimer.factory';

import PALETTE_SCHEMA from './event-disclaimer.palette-schema.yaml';
import SCHEMA from './event-disclaimer.schema.yaml';

class EventDisclaimerFeature extends AbstractVisualFeature {
    get name() {
        return 'EventDisclaimer';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(eventDisclaimerFactory(PALETTE), {
            EventDisclaimer: {
                displayForSports: this.config.displaySportsList,
                infoLink: {
                    link: this.config.infoLinkUrl,
                },
            },
        });
    }

    updateMojitoConfig(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'services.viewImplementations', {
            EventDisclaimer: {
                implementation: EventDisclaimerView,
            },
        });

        super.updateMojitoConfig(mojitoConfig);
    }
}

// Exporting it, as it is used in playground
export const EventDisclaimer = new EventDisclaimerFeature(SportsContent);
